"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconListNumerical = Experimental__IconListNumerical;
exports.IconListNumerical = IconListNumerical;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconListNumerical/index.tsx)
 */
function IconListNumerical(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M.995 15.001a2.66 2.66 0 0 1 .144-.992c.112-.298.293-.581.544-.848a6.348 6.348 0 0 1 1.024-.848c.245-.17.44-.322.584-.456.144-.138.248-.266.312-.384a.756.756 0 0 0 .104-.376.654.654 0 0 0-.064-.296.454.454 0 0 0-.192-.208.664.664 0 0 0-.328-.072.613.613 0 0 0-.368.104.578.578 0 0 0-.216.312 1.608 1.608 0 0 0-.072.52H1.003c0-.48.082-.89.248-1.232.17-.341.418-.6.744-.776.325-.181.717-.272 1.176-.272.442 0 .82.08 1.136.24.314.16.552.376.712.648.16.267.24.563.24.888 0 .278-.054.534-.16.768-.102.235-.267.47-.496.704-.224.23-.528.478-.912.744a5.196 5.196 0 0 0-.424.32c-.107.091-.208.216-.208.216h2.168v1.296H.995ZM15 3H7V1.5h8V3Zm0 5.75v-1.5H7v1.5h8Zm0 5.75H7V13h8v1.5ZM2.907 2.535H1.555V1.44c.49-.026.856-.112 1.096-.256.245-.15.402-.37.472-.664H4.41V6.2H2.907V2.535Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M10 3h12v2H10V3Zm0 8h12v2H10v-2Zm0 8h12v2H10v-2ZM4.402 3.63l.92.87h-2.61V3.04c.613-.033 1.073-.14 1.38-.32a1.23 1.23 0 0 0 .6-.82h1.69V9h-1.98V3.63ZM2.016 21.5a3.4 3.4 0 0 1 .18-1.25c.14-.38.367-.737.68-1.07.32-.34.75-.693 1.29-1.06.293-.207.53-.39.71-.55.18-.167.31-.323.39-.47a.929.929 0 0 0 .12-.45.82.82 0 0 0-.07-.35.49.49 0 0 0-.22-.23.729.729 0 0 0-.38-.09.728.728 0 0 0-.43.12.744.744 0 0 0-.26.37 2.1 2.1 0 0 0-.08.63h-1.92c0-.607.107-1.123.32-1.55a2.22 2.22 0 0 1 .94-.99c.413-.227.91-.34 1.49-.34.567 0 1.05.1 1.45.3.4.2.7.47.9.81.2.333.3.707.3 1.12 0 .347-.067.67-.2.97a2.964 2.964 0 0 1-.62.88 8.757 8.757 0 0 1-1.14.93 5.35 5.35 0 0 0-.52.38 1.63 1.63 0 0 0-.51.64l-.11-.44h3.06v1.69h-5.37Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconListNumerical is deprecated and will be archived soon. Use IconListNumerical instead.
 */
function Experimental__IconListNumerical(props) {
  return /*#__PURE__*/_react["default"].createElement(IconListNumerical, props);
}